import { clientOnly } from '@solidjs/start';
import { Router as BaseRouter, Location } from '@solidjs/router';
import { ParentComponent } from 'solid-js';

import { DialogPC } from './router/Dialog';
import { RouteDefinition, StackContext } from './router/Context';
import { Config, ConfigProps } from './Config';
const ToastProvider = clientOnly(() => import('./toast1'));
const PopProvider = clientOnly(() => import('./Pop'));
const LivingDialogProvider = clientOnly(() => import('./LivingDialog'));

export default function Application(props: {
  children: ParentComponent;
  root: ParentComponent;
  config: ConfigProps;
  routes: any;
  beforeRoute(matche: RouteDefinition, location: Location): string | false;
}) {
  const routes = createMemo(() => props.routes);
  return (
    <BaseRouter
      base="/"
      root={(pps) => {
        return (
          <props.children>
            <Config {...props.config}>
              <StackContext
                location={pps.location}
                beforeRoute={props.beforeRoute}
                baseRoutes={routes().filter((it: any) => it.id !== '/(dialog)')}
              >
                <DialogPC root={props.root} />
              </StackContext>
              <div>
                <PopProvider />
                <ToastProvider />
                <LivingDialogProvider />
              </div>
            </Config>
          </props.children>
        );
      }}
    >
      {routes()}
    </BaseRouter>
  );
}

function fixSolideRouterHashScrollBug() {
  const scrollTo = window.scrollTo;
  // 禁用自动恢复滚动位置
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  window.scrollTo = (x: any, y?: number) => {
    // 当x和y都为0时认为是solidjs/router发起的滚动，忽略它。
    if (y === 0 && x === 0) {
      return;
    }
    scrollTo.call(window, x, y as number);
  };
}

!import.meta.env.SSR && fixSolideRouterHashScrollBug();
